import pump from 'pump'
import ObjectMultiplex from '@metamask/object-multiplex'

import { logError } from '@/shared/logger'

/**
 * Sets up stream multiplexing for the given stream
 * @param connectionStream - the stream to mux
 * @returns the multiplexed stream
 */

export const setupMultiplex = (
  connectionStream: pump.Stream | pump.Callback
): ObjectMultiplex => {
  const mux = new ObjectMultiplex()
  // Ignore some streams to prevent disconnect errors.
  mux.ignoreStream('CONNECTION_READY')

  pump(connectionStream, mux, connectionStream, error => {
    error &&
      !/premature/.test(error.message) &&
      logError(`Error while setting up multiplex:`, error)
  })

  return mux
}
